import { useEffect, useState } from 'react';

function ScrollToTop() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            setIsVisible(window.scrollY > 100);
        };
        toggleVisibility();

        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    return (
        <button
            className={`scroll-to-top ${isVisible ? "visible" : "hidden"}`}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
            <svg className='up-arrow' width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M13 0C13.431 0 13.8444 0.152187 14.1491 0.423063L25.5241 10.5342C26.1586 11.0982 26.1586 12.0129 25.5241 12.5769C24.8895 13.141 23.8606 13.141 23.226 12.5769L14.625 4.93164V24.5556C14.625 25.3533 13.8975 26 13 26C12.1025 26 11.375 25.3533 11.375 24.5556V4.93164L2.77406 12.5769C2.13945 13.141 1.11056 13.141 0.475947 12.5769C-0.158649 12.0129 -0.158649 11.0982 0.475947 10.5342L11.851 0.423063C12.1557 0.152187 12.5691 0 13 0Z" fill="#BFB99B" />
            </svg>
        </button>
    );
}

export default ScrollToTop;
